import { IMdCmFields } from "../types/AppTypes";
import { MdEnableStatusEnum } from "../types/AppEnums";

//系统标识  测试和生产主数据标识区别
export const CLIENT_APP_CODE = "gtm";

export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 30000;

//API请求环境
const baseRequestUrl = {
	"DEV": "http://api.peijian88.cn",
	"STAGE": "http://api.beiben88.com",
	"TEST": "https://test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com"
}

export const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
export const isProdEnv = REACT_APP_ENV === "PROD";

//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
	//自动选择环境
	//....
	return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码
export const INTERNAL_SERVER_ERROR_CODE = 500;
//token存储KEY值
export const TOKEN_KEY = "token";

//获取token
export const getToken = () => {
	return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};

//存储token
export const setToken = (token: string) => {
	sessionStorage.setItem(TOKEN_KEY, token)
};
//通用字段定义
export const defaultMdCmParam: IMdCmFields = {
	sourceApp: "gtm",
	sourceAuthKey: "",
	branch: "gtm",
	ver: undefined,
	enable: MdEnableStatusEnum.ENABLE,
};

export const branchDs = [
	{ label: "财务分支", value: "fms" },
	{ label: "主分支", value: "main" },
	{ label: "外贸分支", value: "gtm" },
]
